export const safeInternalPath = (value: unknown, fallback = '') => {
  const candidate = Array.isArray(value) ? value[0] : value
  if (
    typeof candidate !== 'string' ||
    !candidate.startsWith('/') ||
    candidate.startsWith('//') ||
    candidate.includes('\\')
  ) {
    return fallback
  }
  return candidate
}
